import { render, staticRenderFns } from "./CustoTotalCustoOperacionalPrecoRecebido.vue?vue&type=template&id=2a83c88a&scoped=true&"
import script from "./CustoTotalCustoOperacionalPrecoRecebido.vue?vue&type=script&lang=js&"
export * from "./CustoTotalCustoOperacionalPrecoRecebido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83c88a",
  null
  
)

export default component.exports